<div id="unauthorized-page-container">
    <div id="text-container">
        <h1 class="title">Serving research. Saving confidential data.</h1>

        <div class="content">
            <p>We can automate genotyping, but not page permissions.</p>
            <p class="small-width">
                if you feel like you have reached this in error,<br />
                contact our Genetic Services team will be happy to assist you at <br />
                <a href="mailto: help@transnetyx.com" class="link">help@transnetyx.com</a> or call
                <a href="tel: 888-321-2113" class="link">888-321-2113</a>.
            </p>
        </div>

        <div class="action-buttons">
            <button
                id="error-page-sign-out-btn"
                pButton
                type="button"
                class="p-button p-button-lg"
                [label]="'serverErrorPage.signOut.button.text' | translate"
                (click)="logout()"></button>
            <button
                id="live-chat-btn"
                pButton
                type="button"
                icon="far fa-comments"
                class="p-button-outlined p-button-lg"
                [label]="'serverErrorPage.liveChat.button.text' | translate"
                (click)="openChat()"></button>
        </div>
    </div>

    <div id="image-container">
        <img src="assets/images/illustrations/error_403.svg" alt="server-error-image" />
    </div>
</div>
